import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/esm/Carousel";
import { useHomePageDataSelector } from ".";
import { AD_CAROUSEL_IDS } from "../../../constants";
import BannerDetails from "./BannerDetails";
import DefaultBannerDetails from "./DefaultBannerDetails";

export default function Banner() {
  const carouselData = useHomePageDataSelector().carouselData;
  const [slot1, setSlot1] = useState(
    carouselData?.find((element) => element.slotId === AD_CAROUSEL_IDS.AD_1)
  );

  const [slot2, setSlot2] = useState(
    carouselData?.find((element) => element.slotId === AD_CAROUSEL_IDS.AD_2)
  );

  const [slot3, setSlot3] = useState(
    carouselData?.find((element) => element.slotId === AD_CAROUSEL_IDS.AD_3)
  );

  useEffect(() => {
    // effect
    setSlot1(
      carouselData?.find((element) => element.slotId === AD_CAROUSEL_IDS.AD_1)
    );
    setSlot2(
      carouselData?.find((element) => element.slotId === AD_CAROUSEL_IDS.AD_2)
    );
    setSlot3(
      carouselData?.find((element) => element.slotId === AD_CAROUSEL_IDS.AD_3)
    );
    return () => {
      // cleanup
    };
  }, [carouselData]);
  return (
    <div className="sub-banner-area mt-5">
      <div className="card border-0 rounded-0 bg-back">
        <Carousel
          id="carouselExampleCaptions2"
          className="slide carousel-2"
          data-ride="carousel"
          controls={false}
          interval={6000}
          keyboard={false}
          fade={true}
          slide={false}
        >
          <Carousel.Item>
            <div className="row">
              <div className="col-sm-7">
                <div
                  style={{
                    backgroundImage:
                      slot1?.imagePathFragment &&
                      `url(${slot1?.imagePathFragment})`,
                  }}
                  className="carousel-item__image carousel-item__image_background d-block w-100"
                />
              </div>
              {slot1?.appId ? (
                <BannerDetails carouselSlot={slot1} />
              ) : (
                <DefaultBannerDetails />
              )}
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="row">
              <div className="col-sm-7">
                <div
                  style={{
                    backgroundImage:
                      slot2?.imagePathFragment &&
                      `url(${slot2?.imagePathFragment})`,
                  }}
                  className="carousel-item__image carousel-item__image_background d-block w-100"
                />
              </div>
              {slot2?.appId ? (
                <BannerDetails carouselSlot={slot2} />
              ) : (
                <DefaultBannerDetails />
              )}
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="row">
              <div className="col-sm-7">
                <div
                  style={{
                    backgroundImage:
                      slot3?.imagePathFragment &&
                      `url(${slot3?.imagePathFragment})`,
                  }}
                  className="carousel-item__image carousel-item__image_background d-block w-100"
                />
              </div>
              {slot3?.appId ? (
                <BannerDetails carouselSlot={slot3} />
              ) : (
                <DefaultBannerDetails />
              )}
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
}
